import { Sheet, SheetContent } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { useMobile } from "@/hooks/useMobile";
import { useSidebarStore } from "@/stores/sidebarStore";
import { SidebarNavigation } from "./SidebarNavigation";
import { SidebarHeader } from "./SidebarHeader";
import { SidebarFooter } from "./SidebarFooter";

export function Sidebar() {
  const { isOpen, setSidebar } = useSidebarStore();
  const isMobile = useMobile();

  return (
    <>
      {/* Desktop Sidebar */}
      <aside
        className={cn(
          "fixed left-0 top-0 z-40 h-screen border-r bg-background transition-all duration-300",
          isOpen ? "w-64" : "w-16"
        )}
      >
        <div className="flex h-full w-full flex-col">
          <SidebarHeader collapsed={!isOpen} />
          <div className="flex-1 overflow-y-auto">
            <SidebarNavigation />
          </div>
          <SidebarFooter />
        </div>
      </aside>

      {/* Mobile Sidebar */}
      <Sheet open={isOpen && isMobile} onOpenChange={setSidebar}>
        <SheetContent side="left" className="p-0 w-64">
          <div className="flex h-full flex-col">
            <SidebarHeader collapsed={false} />
            <div className="flex-1 overflow-y-auto">
              <SidebarNavigation />
            </div>
            <SidebarFooter />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
